import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Dropdown from "~/components/CasesDropdown.vue";
import Follow from "~/components/profile/Follow.vue";
import WebpPicture from '~/components/WebpPicture.vue';
export default {
  name: 'profile-informer',
  components: {
    Dropdown: Dropdown,
    Follow: Follow,
    WebpPicture: WebpPicture
  },
  data: function data() {
    return {};
  },
  computed: {
    anchor: function anchor() {
      return this.profileStore.anchorId;
    },
    placement: function placement() {
      return this.profileStore.placement;
    },
    fallbackPlacements: function fallbackPlacements() {
      return this.profileStore.fallbackPlacements || null;
    },
    profile: function profile() {
      return this.profileStore.profile;
    },
    author: function author() {
      return this.profile ? this.profile.author : null;
    },
    sites: function sites() {
      var sites = [];
      if (this.author.site) {
        sites.push({
          link: this.author.site,
          href: this.$link.protocol(this.author.site),
          icon: 'icon-ic-link'
        });
      }
      if (this.author.phone) {
        sites.push({
          link: this.author.phone,
          href: this.$link.phone(this.author.phone),
          icon: 'icon-ic-phone'
        });
      }
      if (this.author.facebook) {
        sites.push({
          link: this.author.facebook,
          href: this.$link.protocol(this.author.facebook),
          icon: 'icon-ic-facebook-logo'
        });
      }
      if (this.author.behance) {
        sites.push({
          link: this.author.behance,
          href: this.$link.protocol(this.author.behance),
          icon: 'icon-ic-behance'
        });
      }
      if (this.author.dribbble) {
        sites.push({
          link: this.author.dribbble,
          href: this.$link.protocol(this.author.dribbble),
          icon: 'icon-ic-dribbble'
        });
      }
      if (this.author.youtube) {
        sites.push({
          link: this.author.youtube,
          href: this.$link.protocol(this.author.youtube),
          icon: 'icon-ic-play-button'
        });
      }
      return sites;
    },
    profileStore: function profileStore() {
      return useProfileStore();
    }
  },
  watch: {
    anchor: function anchor(val) {
      if (this.$refs.dropdown) {
        this.$refs.dropdown.close();
        this.$refs.dropdown.initPopper();
      }
    }
  },
  methods: {
    cleanLink: function cleanLink(link) {
      return link.replace(/^(https?:\/\/)?(www\.)?/i, '');
    }
  }
};